import { Module } from 'vuex';
import { LoginRecordState } from './types';
import { RootState } from '../../types';
import { actions } from './actions';
import { mutations } from './mutations';

const namespaced: boolean = true;
export const state: LoginRecordState = {
    loginRecords: undefined,
    loginRecordCount: 0,
    recFilePath: undefined,
    search: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    csv: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    recFile: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
};

export const loginRecord: Module<LoginRecordState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
};
